import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SideNavButtons from '../components/Common/SideNavButtons';
import { packages } from '../data/package.ts';
import { experiences } from '../data/addons.ts';
import CategoryHeading from '../components/Common/CategoryHeading.js';
import InfoModal from '../components/PackagesCatalog/info_modal.js';
import AddonModal from '../components/PackagesCatalog/addon_modal.js';
import PackageRow from '../components/PackagesCatalog/package_row.js';
import PackageImageRow from '../components/PackagesCatalog/package_image_row.js';
import '../styles/PackagesCatalog.css';

const PackagesCatalog = () => {
  const [showAddonModal, setShowAddonModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [selectedAddon, setSelectedAddon] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const handleAddonClick = (addonName) => {
    const experience = experiences.find(exp => exp.title === addonName);
    if (experience) {
      setSelectedAddon(experience);
      setShowAddonModal(true);
    }
  };

  const handleInfoClick = (pkg) => {
    setSelectedPackage(pkg);
    setShowInfoModal(true);
  };

  const closeInfoModal = () => {
    setShowInfoModal(false);
    setSelectedPackage(null);
  };

  const closeAddonModal = () => {
    setShowAddonModal(false);
    setSelectedAddon(null);
  };

  const navigate = useNavigate();

  const handlePrev = () => {
    navigate('/vehicles');
  };

  const handleNext = () => {
    navigate('/image-gallery');
  };

  return (
    <div className="packages-catalog">
      <CategoryHeading
        title="PACKAGES"
      />

      <div className="machine-gun-header">
        <h2>MACHINE GUN PACKAGES</h2>
        <p>Choose to add additional shooting to your tank package with our new machine gun packages. Prices include ammunition.</p>
      </div>

      <SideNavButtons
        onPrev={handlePrev}
        onNext={handleNext}
        prevPageName="VEHICLES"
        nextPageName="PHOTOS & VIDEOS"
      />

      <PackageImageRow
        images={[
          {
            path: "/img/guns/Vietnam_Rect.png",
            link: "/items-catalog?parent=Packages&category=Vietnam",
            title: "Vietnam",
          },
          {
            path: "/img/guns/WWII_Rect.png",
            link: "/items-catalog?parent=Packages&category=WWII",
            title: "WWII",
          },
          {
            path: "/img/guns/Extreme_Rect.png",
            link: "/items-catalog?parent=Packages&category=Extreme",
            title: "Extreme",
          },
          {
            path: "/img/guns/Modern_Rect.png",
            link: "/items-catalog?parent=Packages&category=Modern+Warfare",
            title: "Modern",
          },
          {
            path: "/img/guns/Pick5_Rect.png",
            link: "/items-catalog?parent=Packages&category=Pick+5",
            title: "Pick 5",
          },
        ]}
      />

      <InfoModal
        show={showInfoModal}
        selectedPackage={selectedPackage}
        onClose={closeInfoModal}
      />

      <AddonModal
        show={showAddonModal}
        selectedAddon={selectedAddon}
        onClose={closeAddonModal}
      />

      <div className="packages-section-header">
        <h2>DRIVE A TANK PACKAGES</h2>
        <p>Drive A Tank, Inc. reserves the right to substitute package features when necessary</p>
      </div>

      <div className="packages-container">
        {packages.map((pkg) => (
          <PackageRow
            key={pkg.id}
            pkg={pkg}
            experiences={experiences}
            onInfoClick={handleInfoClick}
            onAddonClick={handleAddonClick}
          />
        ))}
      </div>
    </div>
  );
};

export default PackagesCatalog;
